var progressBarStyleObject = {
  "animBarDeterminate": {
    "willChange": "width",
    "transition": "width 0.5S cubic-bezier(0.65, 0.815, 0.735, 0.395)"
  },
  "progressBar__progressTrack": {
    "willChange": "width",
    "transition": "width 0.5S cubic-bezier(0.65, 0.815, 0.735, 0.395)",
    "backgroundColor": "#006fcf",
    "height": "100%",
    "position": "relative"
  },
  "animBarIndeterminate": {
    "&::before": {
      "position": "absolute",
      "content": "\"\"",
      "top": "0",
      "left": "0",
      "bottom": "0",
      "backgroundColor": "inherit",
      "willChange": "left, right",
      "WebkitAnimation": "bar-indeterminate 2s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite",
      "animation": "bar-indeterminate 2s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite"
    },
    "&::after": {
      "position": "absolute",
      "content": "\"\"",
      "top": "0",
      "left": "0",
      "bottom": "0",
      "backgroundColor": "inherit",
      "willChange": "left, right",
      "WebkitAnimation": "bar-indeterminate-short 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite",
      "animation": "bar-indeterminate-short 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite",
      "WebkitAnimationDelay": "1.15S",
      "animationDelay": "1.15S"
    }
  },
  "progressBar_progressIndeterminate__progressTrack": {
    "&::before": {
      "position": "absolute",
      "content": "\"\"",
      "top": "0",
      "left": "0",
      "bottom": "0",
      "backgroundColor": "inherit",
      "willChange": "left, right",
      "WebkitAnimation": "bar-indeterminate 2s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite",
      "animation": "bar-indeterminate 2s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite"
    },
    "&::after": {
      "position": "absolute",
      "content": "\"\"",
      "top": "0",
      "left": "0",
      "bottom": "0",
      "backgroundColor": "inherit",
      "willChange": "left, right",
      "WebkitAnimation": "bar-indeterminate-short 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite",
      "animation": "bar-indeterminate-short 2s cubic-bezier(0.165, 0.84, 0.44, 1) infinite",
      "WebkitAnimationDelay": "1.15S",
      "animationDelay": "1.15S"
    },
    "height": "auto",
    "position": "static",
    "transition": "none",
    "width": "auto"
  },
  "keyframesBarIndeterminate": {
    "@keyframes bar-indeterminate": {
      "0%": {
        "left": "-35%",
        "right": "100%"
      },
      "60%": {
        "left": "100%",
        "right": "-90%"
      },
      "100%": {
        "left": "100%",
        "right": "-90%"
      }
    }
  },
  "keyframesBarIndeterminateShort": {
    "@keyframes bar-indeterminate-short": {
      "0%": {
        "left": "-200%",
        "right": "100%"
      },
      "60%": {
        "left": "107%",
        "right": "-8%"
      },
      "100%": {
        "left": "107%",
        "right": "-8%"
      }
    }
  },
  "progressBar": {
    "backgroundColor": "rgba(200, 201, 199, 0.25)",
    "display": "block",
    "height": "0.25rem",
    "position": "relative",
    "overflowX": "hidden",
    "verticalAlign": "middle",
    "width": "auto",
    "zIndex": "0"
  }
};

export default progressBarStyleObject;
